<template>
    <v-data-table
      :headers="headers"
      :items="reverseNetworks"
      :items-per-page="5"
      class="elevation-1 ma-2"
    >
      <template v-slot:item.timestamp="{ item }">
        <span>
          {{ new Date(item.timestamp).toLocaleString('en-GB', { timeZone: 'Europe/Helsinki' })}}
        </span>
      </template>
    </v-data-table>
</template>
<script>
/* eslint-disable */
import Chart from 'chart.js';
import gql from 'graphql-tag';
import moment from 'moment';
import EventBus from '@/utils/EventBus';

const QUERY_WIFI_STATUS = gql`
query query_wifi_status($id: String!, $startTime: timestamptz!, $endTime: timestamptz!) {
  wifi_status (
    where: {
      _and: [
        {
          device_id: {
            _eq: $id
          }
        },
        {
          timestamp: {
            _gt: $startTime
          }
        },
        {
          timestamp: {
            _lt: $endTime
          }
        }
      ]
    }
    order_by: {
      timestamp: asc
    }
  ) {
    timestamp
    available
    enabled
    connected
    ssid
    ip_address
    link_speed
    rssi
    signal_quality
  }
}
`;
const SUBSCRIPTION_WIFI_STATUS = gql`
subscription subscription_wifi_status($id: String!, $timestamp: timestamptz) {
  wifi_status (
    where: {
      device_id: {
        _eq: $id
      }
      timestamp:{
        _gt: $timestamp
      }
    }
    order_by: {
      timestamp: desc
    }
    limit: 1
  ) {
    timestamp
    available
    enabled
    connected
    ssid
    ip_address
    link_speed
    rssi
    signal_quality
  }
}
`;

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    start: {
      type: String,
      required: true,
    },
    end: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      networks: [],
      headers: [
        { text: 'Time', align: 'start', sortable: true, value: 'timestamp' },
        { text: 'Available', value: 'available' },
        { text: 'Enabled', value: 'enabled' },
        { text: 'Connected', value: 'connected' },
        { text: 'SSID', value: 'ssid' },
        { text: 'IP', value: 'ip_address' },
        { text: 'Link speed (Mbps)', value: 'link_speed' },
        { text: 'RSSI', value: 'rssi' },
        { text: 'Signal quality', value: 'signal_quality' },
      ],
      startTime: this.start,
      endTime: this.end,
      subscription: null,
      showNewValues: true,
    };
  },
  computed: {
    reverseNetworks() {
      return this.networks.reverse();
    },
  },
  created() {
    EventBus.$on('monitoring-time-changed', this.reCreateChart);
  },
  beforeDestroy() {
    EventBus.$off('monitoring-time-changed', this.reCreateChart);
  },
  async mounted() {
    await this.getNetworks();
    this.subcribeNewNetworks();
  },
  methods: {
    async reCreateChart(data) {
      this.startTime = data.startTime;
      this.endTime = data.endTime;
      // wait for battery values
      await this.getNetworks();
      /*
      if (data.subscribe) {
        console.log('show new values');
      } else {
        this.stopSubscription();
      }
      */
    },
    stopSubscription() {
      console.log('Don\'t show new values');
    },
    async getNetworks() {
      const result = await this.$apollo.query({
        query: QUERY_WIFI_STATUS,
        variables: {
          id: this.id,
          startTime: this.startTime,
          endTime: this.endTime,
        },
      });

      // create values for chartjs
      this.networks = result.data.wifi_status;
    },
    subcribeNewNetworks() {
      const { id } = this;
      const that = this;
      const timestamp = new Date().toISOString();

      // start subscribing to new cpu values
      this.$apollo.subscribe({
        query: SUBSCRIPTION_WIFI_STATUS,
        variables: {
          id,
          timestamp
        },
      }).subscribe({
          next(data) {
            // got new subscription result
            if (data.data.wifi_status.length > 0) {
              // Add new cpu value to chart
              const [temp] = data.data.wifi_status;
              that.networks.push(temp);
            }
          },
          error(err) { console.error('err', err); },
      });
    },
  },
};
</script>
<style scoped>
</style>
